<template>
  <div id="provider">
    <v-navigation-drawer id="provider-navbar" app> </v-navigation-drawer>
    <v-app-bar id="provider-topnav" app>
      <v-icon id="provider-logo">$vuetify.icons.logo</v-icon>
    </v-app-bar>
    <v-main>
      <div class="primaryBackground">
        <v-container fluid class="pa-8 overflow-y-auto" over>
          <div class="d-inline pt-10">
            <router-link class="back-button pt-10 primary200--text" :to="{ name: 'Dashboard' }">
              <v-icon color="primary200">$vuetify.icons.back</v-icon> {{ $t('back-to-dashboard') }}
            </router-link>
          </div>
          <router-view></router-view>
        </v-container>
      </div>
    </v-main>
  </div>
</template>

<script>
export default {
  name: 'ProviderLayout',
};
</script>
